import React from "react";
import { Download, BookOpen } from "lucide-react";
import { catalogs } from "../mock";
import { PageHeader } from "./Contatti";
import { useToast } from "../hooks/use-toast";

const Cataloghi = () => {
  const { toast } = useToast();
  return (
    <>
      <PageHeader title="Cataloghi" subtitle="Sfoglia o scarica i nostri cataloghi prodotto. Selezione accurata e schede tecniche dettagliate." />
      <section className="py-20 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {catalogs.map((c) => (
            <div key={c.id} className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100">
              <div className="aspect-[3/4] overflow-hidden bg-gray-100">
                <img src={c.cover} alt={c.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <span className="text-[10px] text-[#00A859] font-bold uppercase tracking-wider flex items-center gap-1.5 mb-2">
                  <BookOpen className="w-3 h-3" /> Catalogo
                </span>
                <h3 className="font-bold text-[#0B2545] text-lg mb-1">{c.title}</h3>
                <p className="text-xs text-gray-500 mb-4">{c.pages} pagine · Edizione 2025</p>
                <button onClick={() => toast({ title: "Download avviato", description: c.title })} className="w-full inline-flex items-center justify-center gap-2 bg-[#00A859] hover:bg-[#00874A] text-white font-bold text-xs uppercase tracking-wide px-4 py-3 rounded-full transition-colors">
                  <Download className="w-3.5 h-3.5" /> Scarica PDF
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Cataloghi;
